import React from 'react';
import styled from '@emotion/styled';
import JobsCard from '../../../../components/Card/JobsCard';
import { useAppSelector } from '../../../../redux/store';

const ActiveJobs = () => {
  const jobsCreatedList = useAppSelector((state) => state.activeJobsList);

  const jobs = jobsCreatedList.jobData;

  return (
    <Container>
      {jobs.map((job, index) => (
        <JobsCard
          key={index}
          institutionName={job.institutionName}
          description={job.jobDescription}
          xp={job.yearsOfExperience}
          pay={job.pay}
          jobId={job.id}
          payInterval={job.payInterval}
        />
      ))}
    </Container>
  );
};

export default ActiveJobs;

const Container = styled.div`
  display: flex;
  gap: 2rem;
  flex-wrap: wrap;
`;
